export function updateElementVisibility(element: HTMLElement, show: boolean, visibility: string) {
	// Add null/undefined check
	if (!element || !element.classList) {
		console.warn("updateElementVisibility called with invalid element:", element);
		return;
	}

	if (show) {
		element.classList.remove("hide");
		// When showing, set the display property to the visibility value
		element.style.display = visibility;
	} else {
		element.classList.add("hide");
		// When hiding, apply the display none (with or without !important)
		if (visibility.includes("!important")) {
			element.style.setProperty("display", "none", "important");
		} else {
			element.style.display = "none";
		}
	}
}
